import * as React from "react";

import { EditPropertySectionLeaseContractHistory } from "./History";

interface EditPropertySectionLeaseContractProps {
  onClickPageBack: () => void;
}

export const EditPropertySectionLeaseContract: React.FC<EditPropertySectionLeaseContractProps> = ({
  onClickPageBack,
}) => {
  return <EditPropertySectionLeaseContractHistory onClickPageBack={onClickPageBack} />;
};
